import log from 'salvo-lite/log'
import Choices from 'choices.js'

class ChoicesSelect {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._choices = null
        window.choiceObjects = window.choiceObjects || []
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this._choices = new Choices(this._elem, {
            searchEnabled: false,
            removeItems: false,
            paste: false,
            itemSelectText: '',
            shouldSort: false
        })

        this._elem.addEventListener('update-choices', e => {
            alert('event triggered')
            this._choices.setValueByChoice(e.detail)
        })

        window.choiceObjects.push(this._choices)
        log.debug(this.constructor.name, 'Initiated')
    }

    getChoices () {
        return this._choices
    }

    setValue (newValue) {
        this._choices.setValueByChoice(newValue)
        this._elem.dispatchEvent(new Event('change'))
    }
}

export default ChoicesSelect



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ChoicesSelect.js